import { useContext } from 'react';
import { ModalContext, type ModalContextType } from './ModalContext';

/**
 * Hook to access Modal Context
 * Must be used within ModalProvider
 */
export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);

  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }

  return context;
};
